import React from 'react';
const SkipButton = ({ onSkip }) => (
  <button className="btn btn--skip" onClick={onSkip}>Skip Intro</button>
);
export default SkipButton;